import React, { memo, useLayoutEffect } from "react";
import MobileHeader from "./Mobile/MobileHeader";
import DesktopHeader from "./Desktop/DesktopHeader";
import { DesktopDown, Desktop } from "theme/Breakpoints";
import Breadcrumb from "features/breadcrumb";
import { useDispatch } from "react-redux";
import { getMenuItems } from "features/header/headerSlice";
import { useLocation } from "react-router-dom";
const AppHeader = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");

  useLayoutEffect(() => {
    dispatch(getMenuItems());
  }, []);

  if (isSitemap || isLogin) return null;

  return (
    <>
      <DesktopDown>
        <MobileHeader />
      </DesktopDown>
      <Desktop>
        <DesktopHeader />
      </Desktop>
      <Breadcrumb />
    </>
  );
};

export default memo(AppHeader);
